import "../../../static/js/loaders/jquery";

$(".r-selected option:selected").each(function () {
    var currentElement = $(this);
    var value = currentElement.attr('moreData');
    var dataId = currentElement.closest('select').attr('data-id')
    console.log(value)
    if (value == "True") {

        $('#learningCenterInfo-id-' + dataId).children().css('display', 'none')
        $('#otherLearningCenter-id-' + dataId).children().css('display', '')
        $('#otherLearningCenter-id-' + dataId).children().css('display', '')

        var modId = '#otherLearningCenter-id-' + dataId + ' :input'
        $(modId).attr("disabled", false);

    }
    else {
        $('#otherLearningCenter-id-' + dataId).children().css('display', 'none')
        $('#learningCenterInfo-id-' + dataId).children().css('display', '')
        $('#learningCenterInfoBox-id-' + dataId).val(currentElement.attr('info'))

        var modId = '#otherLearningCenter-id-' + dataId + ' :input'
        $(modId).attr("disabled", true);
    }


});

$(".r-selected").on("change", function () {

    var SelectedItem = "#" + this.id + " option:selected"
    console.log('selectedItem ', $(SelectedItem).attr('moreData'))

    var dataId = $(this).attr('data-id')

    if ($(SelectedItem).attr('moreData') == "True") {
        $('#learningCenterInfo-id-' + dataId).children().css('display', 'none')
        $('#otherLearningCenter-id-' + dataId).children().css('display', '')
        // $(".OtherLearningCenter :input").attr("disabled", false);

        var modId = '#otherLearningCenter-id-' + dataId + ' :input'
        $(modId).attr("disabled", false);
    }
    else {
        $('#otherLearningCenter-id-' + dataId).children().css('display', 'none')
        $('#learningCenterInfo-id-' + dataId).children().css('display', '')
        $('#learningCenterInfoBox-id-' + dataId).val($(SelectedItem).attr('info'))
        // $(".OtherLearningCenter :input").attr("disabled", true);

        var modId = '#otherLearningCenter-id-' + dataId + ' :input'
        $(modId).attr("disabled", true);
    }






})











